import NewButton from "../Atomos/Buttons/newButton";
import Sync from "../Atomos/Icons/Sync";
import { useStaffMode } from "../../hooks/StaffModeProvider";

type FilterButtonProps = {
  handleFormReset: () => void;
  headers?: string[];
  onClickSearch?: () => void;
  tableInstance?: any;
  noColumns?: boolean;
  member?: boolean;
};

const CatalogFilterButtons: React.FC<FilterButtonProps> = ({
  handleFormReset,
}) => {
  const { isStaffMode } = useStaffMode();
  
  return (
    <div className="flex flex-col md:flex-row items-end justify-end gap-2 flex-1 md:min-h-9 md:flex-none w-fit">
      <NewButton
        onClick={handleFormReset}
        text="Clear Filters"
        content="textIcon"
        icon={<Sync />}
        style="ghost"
        color={isStaffMode ? "accent":"primary"}
        size="large"
      />
    </div>
  );
};

export default CatalogFilterButtons;
